export type WeatherPopupData = {
  modelId: string;
  data:
    | { field: string; value: number; unit: string; tiffValue: number }[]
    | null;
};
